export function compareByName(
  first: { name: string },
  second: { name: string },
): number {
  return first.name.localeCompare(second.name, undefined, {
    sensitivity: 'base',
    numeric: true,
  });
}
